import * as React from 'react';

import IconFileBase from './IconFileBase';
import { Icon } from '../iconTypes';

const IconFileCode = (props: Icon) => (
    <IconFileBase {...props} baseClassName="icon-file-code">
        <path d="M25 27H7V5h13l5 5v17z" fill="#fff" />
        <path
            d="M20 19h1v1h-1zM20 13h-3v1h2v3h1v-4zM19 23h-2v1h3v-4h-1v3zM21 18h1v1h-1zM20 17h1v1h-1zM11 24h3v-1h-2v-3h-1v4zM10 19h1v1h-1zM10 17h1v1h-1zM9 18h1v1H9zM12 14h2v-1h-3v4h1v-3z"
            fill="#e33d55"
        />
        <path
            d="M20 4H7a.94.94 0 0 0-1 1v22a.94.94 0 0 0 .88 1H25a.94.94 0 0 0 1-1V9.9zm5 23H7V5h13v4a.94.94 0 0 0 .88 1H25z"
            fill="#e33d55"
        />
    </IconFileBase>
);

export default IconFileCode;
